<template>
  <div class="view-roles addedit-role">
    <vx-card :title="$t('labels.user_profile')">
      <vs-button
        color="dark"
        type="filled"
        icon-pack="feather"
        icon="icon-edit"
        class="sm: mr-0 ml-4 edit-profile"
        align="center"
        :to="{name:'EditProfile'}"
      >{{ $t('labels.edit_profile') }}</vs-button>
      <vs-button
        v-if="user && user.type === 'CN'"
        @click="downloadDocument()"
        type="filled"
        :title="$t('labels.consultant_details')"
        icon-pack="feather"
        icon="icon-download"
        color="danger"
        align="center"
        class="sm: mr-0 edit-profile"
      >{{ $t('labels.consultant_details') }}</vs-button>
      <div class="vx-row w-full">
        <div class="vx-col w-full mb-4">
          <div class="vx-row w-full">
            <div class="vx-col sm: w-full md:w-1/2 mb-4">
              <div class="vx-row mb-0">
                <div class="vx-col sm: w-1/2">
                  <label>{{ $t('labels.name') }}:</label>
                </div>
                <div class="vx-col sm: w-1/2">
                  <span>{{ user.name }}</span>
                </div>
              </div>
            </div>
            <div class="vx-col sm: w-full md:w-1/2 mb-4 sm: mt-4 md:mt-0">
              <div class="vx-row">
                <div class="vx-col sm: w-1/2">
                  <label>{{ $t('labels.organisation_name') }}:</label>
                </div>
                <div class="vx-col sm: w-1/2">
                  <span>{{ user.organisation_name ? user.organisation_name : '-'}}</span>
                </div>
              </div>
            </div>
          </div>
          <div class="vx-row w-full">
            <div class="vx-col sm: w-full md:w-1/2 mb-4">
              <div class="vx-row mb-0">
                <div class="vx-col sm: w-1/2">
                  <label>{{ $t('labels.email') }}:</label>
                </div>
                <div class="vx-col sm: w-1/2">
                  <span>{{ user.email }}</span>
                </div>
              </div>
            </div>
            <div class="vx-col sm: w-full md:w-1/2 mb-4 sm: mt-4 md:mt-0">
              <div class="vx-row">
                <div class="vx-col sm: w-1/2">
                  <label>{{ $t('labels.type') }}:</label>
                </div>
                <div class="vx-col sm: w-1/2">
                  <span>{{ user.type_name }}</span>
                </div>
              </div>
            </div>
          </div>
          <div class="vx-row w-full">
            <div class="vx-col sm: w-full md:w-1/2 mb-4">
              <div class="vx-row mb-0">
                <div class="vx-col sm: w-1/2">
                  <label>{{ $t('labels.previous_login_at') }}:</label>
                </div>
                <div class="vx-col sm: w-1/2">
                  <span>{{ previous_login_at | date_format }}</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </vx-card>
    <consultant-detail-view v-if="user && user.type === 'CN'" class="mt-6"></consultant-detail-view>
  </div>
</template>
<script>
import ConsultantDetailView from "@/views/users/consultant-details-view";

export default {
  data() {
    return {
      user: {},
      modules: [],
      previous_login_at: null
    };
  },
  components: {
    ConsultantDetailView
  },
  mounted() {
    this.getUserDetails();
  },
  methods: {
    async getUserDetails() {
      let response = await this.getHTTPPostResponse("/profile");
      if (response) {
        this.user = response.data.user;
        this.previous_login_at = response.data.previous_login_at;
      }
    },
    goBack() {
      history.back();
    },
    async downloadDocument() {
      this.$vs.loading();
      let input = {};
      if (this.$store.state.userInfo.type === "A") {
        input = Object.assign(
          {
            user_id: this.$route.params.id
          },
          input
        );
      }
      this.axios
        .post("/consultants/report", input, {
          responseType: "arraybuffer"
        })
        .then(response => {
          let data = response.data;
          var currentDate = new Date();
          var formatted_date = new Date()
            .toJSON()
            .slice(0, 10)
            .replace(/-/g, "_");
          let pdfName = this.$store.state.userInfo.name + "_" + formatted_date;
          this.exportPdfFile(data, pdfName);
          this.export = 0;
          this.$vs.loading.close();
        })
        .catch(e => {
          console.log("e", e);
        });
    }
  }
};
</script>
<style scoped>
.view-roles h3 {
  font-weight: 600;
  margin-right: 10px;
  font-size: 17px;
  text-decoration: underline;
  color: rgba(var(--vs-primary), 1) !important;
}
.view-roles label {
  font-weight: 600;
  font-size: 17px !important;
}
.edit-profile {
  color: #fff;
  top: -73px;
  float: right;
}
.edit-profile .vs-button--text {
  color: #fff !important;
}
</style>

